export const UNAUTHENTICATED_USER_ID = 'universal-id'

export const NEW_UI_AGENT_PUBLIC_PROFILE = 'new_ui_agent_public_profile'
